import { Observable, UnaryFunction } from 'rxjs';
import { bufferTime, map, filter } from 'rxjs/operators';

export const keyDebounceTime = <T>(
  debounceTime: number,
  keySelector: (value: T) => string
): UnaryFunction<Observable<T>, Observable<T[]>> => {
  return (observable: Observable<T>) => {
    return observable.pipe(
      filter((action) => !!action),
      bufferTime(debounceTime),
      filter((actions) => !!actions.length),
      map((actions: T[]) => {
        const keys: any = {};

        const filtered = actions.slice().reverse().filter((action) => {
          const key = keySelector(action);
          if (!(key in keys)) {
            keys[key] = true;
            return true
          }
          return false
        });

        // only emit the latest update for each recordLabelId
        return filtered;
      })
    ) as Observable<T[]>;
  }
};